import React from 'react'

export const ModalHeader = () => <wb-modal-header></wb-modal-header>
